import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  return (
    <div>
      <h1 className="font-serif text-3xl text-pitch mb-8">Customers</h1>
      <div className="bg-white border border-linen overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead><tr className="text-left text-stonemuted border-b border-linen">
            {["Name", "Email", "Orders", "Joined", "Provider"].map((h) => <th key={h} className="px-4 py-3 font-mono text-xs uppercase tracking-wider">{h}</th>)}
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={5} className="px-4 py-12 text-center text-stonemuted">Loading…</td></tr>
              : customers.length === 0 ? <tr><td colSpan={5} className="px-4 py-12 text-center text-stonemuted">No customers yet.</td></tr>
              : customers.map((c) => (
                <tr key={c.id} className="border-b border-linen/60">
                  <td className="px-4 py-3">{c.name || "—"}</td>
                  <td className="px-4 py-3">{c.email}</td>
                  <td className="px-4 py-3">{c.order_count}</td>
                  <td className="px-4 py-3 text-xs text-stonemuted">{c.created_at ? new Date(c.created_at).toLocaleDateString("en-AU") : "—"}</td>
                  <td className="px-4 py-3 text-xs font-mono uppercase">{c.auth_provider}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
